import MobBathCollectionSection from './MobBathCollectionSection';

export default MobBathCollectionSection;
